import styled from "styled-components";

const ProfessionalSubEspecialty = styled.p`
	font-family: "Livvic";
	font-style: normal;
	font-weight: 400;
	font-size: 12.5px;
	line-height: 165.5%;
	letter-spacing: 0.005em;
	color: ${props => props.theme.colors.blackVitat || "#002b49"};
	text-align: left;
	width: 100%;
	margin: 0;
`;

export default ProfessionalSubEspecialty;
